import React from 'react';
import {FeatureBoxOne, SecTitle, TitleWrap} from '../../components/';
import Slider from 'react-slick';
import FeatureBoxOneEInvoice from "../../components/FeatureBox/FeatureBoxOneEInvoice";

const FeatureOneEInvoice = ({data,className})=> {
  
  return (
    <div className={`s feature-wrap1 ${className || ''}`}  style={{backgroundImage: 'url(images/bg/sr-bg-2-1.jpg)'}}>
        <div className="container">
            <div className="container space-extra-bottom">
                <TitleWrap className="text-center space-top ">
                    <SecTitle className="text-capitalize h3">Integration Timeline & Phases</SecTitle>
                </TitleWrap>

            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-center">
                {
                    data?.map(item => {
                        return (
                            <FeatureBoxOneEInvoice
                                title={item?.title}
                                text={item?.text}
                                image={item?.image}
                            />
                        )
                    })
                }
            </div>
        </div>
    </div>
  );
}

export default FeatureOneEInvoice;